import React from 'react'
import {Route, Routes } from 'react-router-dom'
import LandingPage from './AILandingPageComponent/LandingPage'
import { ChatBotProvider } from './ChatBotComponent/ChatBotContext'
import FloatingChatbot from './ChatBotComponent/FloatingChatBot'
import SocietyBogs from './BlogSectionComponenet/SocietyBogs'

const LandingPageAIComponent = () => {
  return (
    <ChatBotProvider>
    {/* <FloatingChatbot/> */}
    <Routes>
    <Route path='/' element={<LandingPage/>}/>
    <Route path='/blogs' element={<SocietyBogs/>}/>

    </Routes>
    </ChatBotProvider>
  )
}

export default LandingPageAIComponent